<form
    name="signup-form"
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
>
    <div class="form-container">
        <div class="row">
            <div
                class="col-md-12"
                style="margin-bottom: 20px;"
            ><span class="required fa fa-asterisk"></span> Indicates required fields.</div>
            <div
                class="col-md-12"
                style="margin-bottom: 20px;"
            ><span *ngIf="brandId == BrandEnum.CELPIP"> Please enter your full name, date of birth, and gender exactly as shown on your identification document. <a href="https://www.celpip.ca/take-celpip/test-day-information/" target="_blank">Click here</a> to view a list of acceptable identification documents for your CELPIP Test.</span>
             <span *ngIf="brandId == BrandEnum.CAEL">  Please enter your full name, date of birth, and gender exactly as shown on your identification document. <a href="https://www.cael.ca/take-cael/accepted-identification/" target="_blank">Click here</a> to view a list of acceptable identification documents for your CAEL Test.</span></div>            
        </div>
        <div class="row">
            <div class="col-md-5">
                <div class="form-group">
                    <label>Email Address <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="email"
                        formControlName="email"
                        autocomplete="off"
                        class="form-control"
                        name="email"
                        placeholder="Email"
                        maxlength="128"
                        [ngClass]="{ 'is-invalid': f.email.dirty && f.email.errors?.required|| submitted && f.email.errors?.email }"
                        data-qa="create-account-email"
                    />
                    <small
                        class="error"
                        *ngIf="emailInUseMessage"
                    >{{emailInUseMessage}}</small>
                    <small
                        class="error"
                        *ngIf="f.email.errors?.pattern"
                    >Please include a @ in your email.</small>
                    <small
                        class="error"
                        *ngIf="f.email.errors?.email && !f.email.errors?.pattern"
                    >Please enter a valid email.</small>
                    <small
                        class="error"
                        *ngIf="f.email.dirty && f.email.errors?.required"
                    >Please enter an email.</small>
                </div>
                <div class="form-group">
                    <label>Confirm Email Address<span class="required fa fa-asterisk"></span></label>
                    <input
                        type="email"
                        formControlName="emailConfirm"
                        autocomplete="off"
                        class="form-control"
                        name="emailConfirm"
                        placeholder="Confirm Email"
                        (paste)="$event.preventDefault()"
                        maxlength="128"
                        [ngClass]="{ 'is-invalid': f.emailConfirm.dirty && f.emailConfirm.errors?.required || submitted && f.email.value != f.emailConfirm.value}"
                        data-qa="create-account-confirm-email"
                    />

                    <small
                        class="error"
                        *ngIf="f.email.value && f.emailConfirm.value && f.email.value != f.emailConfirm.value"
                    >Please enter matching emails.</small>
                    <small
                        class="error"
                        *ngIf="f.emailConfirm.dirty && f.emailConfirm.errors?.required"
                    >Please confirm your email.</small>
                </div>
                <div class="form-group" style="margin-bottom: 35px;">
                    <label>Password <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="password"
                        formControlName="password"
                        autocomplete="off"
                        class="form-control"
                        name="password"
                        placeholder="Password"
                        maxlength="128"
                        [ngClass]="{ 'is-invalid': f.password.dirty && f.password.errors?.required || submitted && f.password.errors?.pattern}"
                        data-qa="create-account-password"
                    />
                    <app-password-strength-meter [newPassword]="f.password.value"></app-password-strength-meter>
                    <small
                        class="error"
                        *ngIf="f.password.errors?.pattern"
                    >Must be at least 8 characters long and a mixture of numbers and letters.</small>
                    <small
                        class="error"
                        *ngIf="f.password.dirty && f.password.errors?.required"
                    >Please enter a password.</small>
                </div>
                <div class="form-group">
                    <label>Confirm Password <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="password"
                        formControlName="passwordConfirm"
                        autocomplete="off"
                        class="form-control"
                        name="passwordConfirm"
                        placeholder="Confirm Password"
                        [ngClass]="{ 'is-invalid': f.passwordConfirm.dirty && f.passwordConfirm.errors?.required || submitted && f.passwordConfirm.value != f.password.value}"
                        data-qa="create-account-confirm-password"
                    />
                    <small
                        class="error"
                        *ngIf="f.password.value && f.passwordConfirm.value && f.passwordConfirm.value != f.password.value"
                    >Please enter matching passwords.</small>
                    <small
                        class="error"
                        *ngIf="f.passwordConfirm.dirty && f.passwordConfirm.errors?.required"
                    >Please confirm your password</small>
                </div>
            </div>

            <div class="col-md-5">
                <div class="form-group">
                    <label>First Name <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        formControlName="firstName"
                        class="form-control"
                        name="firstName"
                        placeholder="First Name"
                        maxlength="50"
                        [ngClass]="{ 'is-invalid': f.firstName.dirty && f.firstName.errors?.required }"
                        data-qa="create-account-firstName"
                    />
                    <small
                        class="error"
                        *ngIf="f.firstName.dirty && f.firstName.errors?.required"
                    >Please enter your first name.</small>
                    <small
                        class="error"
                        *ngIf="f.firstName.errors?.pattern"
                    >Only English characters are accepted.</small>
                </div>
                <div class="form-group">
                    <label>Middle Name</label>
                    <input
                        type="text"
                        formControlName="middleName"
                        class="form-control"
                        name="middleName"
                        placeholder="Middle Name"
                        maxlength="50"
                    />
                    <small
                        class="error"
                        *ngIf="f.middleName.errors?.pattern"
                    >Only English characters are accepted.</small>
                </div>
                <div class="form-group">
                    <label>Last Name <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        formControlName="lastName"
                        class="form-control"
                        name="lastName"
                        placeholder="Last Name"
                        maxlength="50"
                        [ngClass]="{ 'is-invalid': f.lastName.dirty && f.lastName.errors?.required }"
                        data-qa="create-account-lastName"
                    />
                    <small
                        class="error"
                        *ngIf="f.lastName.dirty && f.lastName.errors?.required"
                    >Please enter your last name.</small>
                    <small
                        class="error"
                        *ngIf="f.lastName.errors?.pattern"
                    >Only English characters are accepted.</small>
                </div>
                <div class="form-group">
                    <label>Birth Date <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="date"
                        max="{{today | date:'yyyy-MM-dd'}}"
                        min="{{minBirthDate | date:'yyyy-MM-dd'}}"
                        class="form-control"
                        formControlName="birthDate"
                        name="birthday"
                        placeholder="Click to select"
                        (change)="checkAge()"
                        [ngClass]="{ 'is-invalid': f.birthDate.dirty && f.birthDate.errors?.required }"
                        data-qa="create-account-birthDate"
                    />
                    <small
                        class="error"
                        *ngIf="f.birthDate.dirty && f.birthDate.errors?.required"
                    >Please enter your birthdate.</small>
                    <small
                        class="error"
                        *ngIf="showNotValidAgeWarning === true"
                    >Please enter a valid birthdate.</small>
                    <div
                        class="alert alert-warning fadeInDiv"
                        style="margin-top: 6px;"
                        *ngIf="showU18Warning === true"
                    >
                        <p>
                            Test Takers <strong>under the age of 18</strong> are required to fill out our manual CELPIP Registration Form.
                        </p>
                        <p>Please <a
                                href="https://www.celpip.ca/wp-content/uploads/2021/03/CELPIP-Registration-Form-for-Minors-2021.pdf"
                                target="_blank"
                            >click here</a> to download and print this form.</p>
                        <p>For other inquiries, please contact our office at 1-800-958-5186 or info@celpip.ca.</p>
                    </div>
                </div>
                <div class="form-group">
                    <label>Gender <span class="required fa fa-asterisk"></span></label>
                    <select
                        class="form-control"
                        formControlName="gender"
                        name="gender"
                        [ngClass]="{ 'is-invalid': f.gender.dirty && f.gender.errors?.required }"
                        data-qa="create-account-gender"
                    >
                        <option value="F">Female</option>
                        <option value="M">Male</option>
                        <option value="X">X</option>
                    </select>
                    <small
                        class="error"
                        *ngIf="f.gender.dirty && f.gender.errors?.required"
                    >Please enter your gender.</small>
                </div>
            </div>
        </div>
        <hr *ngIf="!isForAffiliate" />

        <div
            class="row sms-notification-consent"
            *ngIf="!isForAffiliate"
        >
            <div class="col-md-12">
                <h4>Text Message Notifications</h4>
                <br />
                <app-sms-notification-consent
                    [isCreateAccountMode]="true"
                    [formGroup]="userForm"
                ></app-sms-notification-consent>
            </div>
        </div>

        <hr />

        <div class="row reviewOrder">
            <div class="col-md-12">
                <h4>Service Terms</h4>
                <div class="form-group">
                    <p>Please read the following Paragon Testing Enterprises Terms for Testing Sessions and Instructional Materials and the Paragon Testing Enterprises General Terms of Service.</p>
                </div>
                <div class="terms-and-conditions">
                    <div [innerHtml]="serviceTermContent"></div>
                </div>

                <br />
                <a
                    href="{{regPoliciesUrl}}"
                    target="_blank"
                >View our transfer, cancellation, and retake policies.</a>

                <div class="consent-checkbox">
                    <input
                        type="checkbox"
                        [checked]="personalInfoAgreement"
                        formControlName="personalInfoAgreement"
                        name="personalInfoAgreement"
                        data-qa="create-account-personalInfoAgreement"
                    />
                    <span>I certify that I am the person whose name and personal information are in the registration form and that I personally provided all of the information. I also certify that all of the information included in the registration form is true and complete.</span>
                </div>

                <div class="consent-checkbox">
                    <input
                        type="checkbox"
                        [checked]="serviceTermAgreement"
                        formControlName="serviceTermAgreement"
                        name="serviceTermAgreement"
                        data-qa="create-account-serviceTermAgreement"
                    />
                    <span>I have read, understand and agree to the Paragon Testing Enterprises Service Terms for Testing Sessions and Instructional Materials and the Paragon Testing Enterprises General Terms of Service (both displayed in the scrollable window above).</span>
                </div>

                <div class="consent-checkbox">
                    <input
                        type="checkbox"
                        [checked]="privacyPolicyAgreement"
                        formControlName="privacyPolicyAgreement"
                        name="privacyPolicyAgreement"
                        data-qa="create-account-privacyPolicyAgreement"
                    />
                    <span>I have read and understand the Paragon Testing Enterprises Privacy Policy (displayed in the scrollable window above) and consent to the collection, use, disclosure, retention, and deletion of my personal information in accordance with the Paragon Testing Enterprises Privacy Policy and as otherwise permitted by applicable law.</span>
                </div>

                <div
                    class="consent-checkbox fadeInDiv"
                    *ngIf="showU19Warning === true"
                >
                    <input
                        type="checkbox"
                        [checked]="ageAgreement"
                        formControlName="ageAgreement"
                        name="ageAgreement"
                    />
                    <span>If I am under the age of majority in the jurisdiction in which I live, then in addition to my own agreements and consents (confirmed above) my parent or legal guardian: (1) has read, understands and agrees on my behalf to both the Paragon Testing Enterprises Service Terms for Testing Sessions and Instructional Materials and the Paragon Testing Enterprises General Terms of Service; and (2) consents on my behalf to the collection, use, disclosure, retention and deletion of my personal information in accordance with the Paragon Privacy Policy and as otherwise permitted by applicable law.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    By continuing you are confirming that the information you've entered is correct and agree to our Service Terms.
                </div>
                <br />
                <div class="form-group">
                    <ng-container *ngIf="!shouldUseHCaptcha">
                        <re-captcha #recaptcha
                                    [siteKey]="recaptchaSiteKey"
                                    (resolved)="onCaptchaResolved($event)">
                        </re-captcha>
                    </ng-container>
                    <ng-container *ngIf="shouldUseHCaptcha">
                        <div 
                            class="h-captcha" 
                            [attr.data-sitekey]="hcaptchaSiteKey"
                            data-callback="onCaptchaResolved"
                            data-error-callback="onCaptchaError">
                        </div>
                    </ng-container>
                </div>                 
                <div class="form-group">
                    <button
                        type="submit"
                        name="confirmationYesBtn"
                        class="btn btn-primary"
                        [disabled]="!userForm.valid && (!userForm.controls.smsPhoneNumber.value || userForm.controls.smsPhoneNumber.value.e164Number.length !== 12 || userForm.controls.smsPhoneNumber.value.e164Number.indexOf('753') !== 2)
                        || !f.personalInfoAgreement.value || !f.serviceTermAgreement.value || !f.privacyPolicyAgreement.value || (!f.ageAgreement.value && showU19Warning === true) || showU18Warning === true"
                        data-qa="create-account-signUpBtn"
                    >
                        Sign Up
                    </button>
                </div>
            </div>
        </div>
    </div>
    <app-modal
        #confirmEmailModal
        title="Create Account Confirmation"
        body="Thank you for creating an account.
              Your account was created using the following email address: {{ f.email.value }}
              Is this correct?"
        (clickPositive)="checkEmailAndCreateAccount()"
        isConfirm="true"
    >
    </app-modal>
</form>
